export default __webpack_public_path__ + "static/EzyMedical BM - Mobile Banner (EDP)-f5fbfd7232c178cabe4f6fa4729fe8c9.png";